const schedule = [
  {
    day: "Monday",
    checked: false,
    timeSlots: [{ from: "00:00", to: "23:59" }],
  },
  {
    day: "Tuesday",
    checked: false,
    timeSlots: [{ from: "00:00", to: "23:59" }],
  },
  {
    day: "Wednesday",
    checked: false,
    timeSlots: [{ from: "00:00", to: "23:59" }],
  },
  {
    day: "Thursday",
    checked: false,
    timeSlots: [{ from: "00:00", to: "23:59" }],
  },
  {
    day: "Friday",
    checked: false,
    timeSlots: [{ from: "00:00", to: "23:59" }],
  },
  {
    day: "Saturday",
    checked: false,
    timeSlots: [{ from: "00:00", to: "23:59" }],
  },
  {
    day: "Sunday",
    checked: false,
    timeSlots: [{ from: "00:00", to: "23:59" }],
  },
];

export default schedule;


